export default __webpack_public_path__ + "static/booking-request-d86b99ac919172279d888b2accf183a0.png";